import { render, staticRenderFns } from "./newoutline.vue?vue&type=template&id=5a70dc18&scoped=true&"
import script from "./newoutline.vue?vue&type=script&lang=js&"
export * from "./newoutline.vue?vue&type=script&lang=js&"
import style0 from "./newoutline.vue?vue&type=style&index=0&id=5a70dc18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a70dc18",
  null
  
)

export default component.exports